<template>
    <div
        class="client-card side-card without-discount active"
        :class="actionsAllowed ? '' : 'disabled'"
        v-if="clientType == 'wodiscount'"
    >
        <div
            class="client-info d-flex align-items-center justify-content-between"
            v-if="!showPromocodeSelect && !chosenPromocode"
        >
            <h4 class="client-name" @click.prevent="changeClient">
                <span class="client-edit">
                  <v-icon
                      color="green"
                  >
                    mdi-pencil
                  </v-icon>
                  </span>
              Клиент без скидки
            </h4>
            <small class="d-block">
              <a data-test-id="hasPromo" href="#" @click.prevent="showPromocodes()">
                У меня есть промокод
              </a>
            </small>
        </div>
        <div
            class="client-discount-info d-flex align-items-center justify-content-between mt-3 row"
            v-if="showPromocodeSelect || chosenPromocode"
        >
            <div class="client-discount col-6" v-if="chosenPromocode">
                <span>
                    <small
                        >{{ Math.trunc(chosenPromocode.amount) }}
                        {{ chosenPromocode.type == "percents" ? "%" : "руб." }}
                        по промокоду</small
                    >
                </span>
            </div>
            <div class="promocode col-6 py-0">
                <div class="form-row">
                    <div class="form-group d-flex align-center">
                      <v-autocomplete
                          class="promocode-autocomplete"
                          name="select-promocode"
                          v-model="chosenPromocode"
                          item-text="display_title"
                          :items="promocodes"
                          :menu-props="{ maxHeight: 450 }"
                          filled
                          solo
                          dense
                          return-object
                          data-test-id="promoInput"
                      >
                        <template v-slot:item="{ item }">
                          <div :data-test-id="`promoValue-${item.code}`">
                            {{ item.code }}
                          </div>
                        </template>
                      </v-autocomplete>

                        <small class="d-block ml-2">
                          <v-icon @click.prevent="closePromo">
                            mdi-close-circle
                          </v-icon>
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <router-link
            tag="div"
            to="/order/clientcard"
            class="client-car-info d-flex align-items-center justify-content-between mt-3 px-2 py-2"
        >
            <div
                class="car-mark car-color"
                :class="chosenMark ? '' : 'car-blue'"
            >
                <img
                    v-if="chosenMark"
                    :src="'/images/cars/marks/' + chosenMark + '.png'"
                    alt=""
                />
                <h5 class="car-name ml-2">
                    {{ chosenMark }} {{ chosenModel }}
                </h5>
            </div>
            <div
                class="tire-diameter d-flex align-items-center justify-content-between"
            >
                <b class="diameter mr-2">{{ diskSize }}</b>
                <img src="img/services/icons/diameter.png" alt="" />
            </div>
        </router-link>
        <div
            class="left-to-discount position-relative d-flex align-items-center justify-content-between mt-3 px-3 py-2"
        >
            <div class="">
                <p class="left-text ml-2">Cкидка не предоставляется</p>
            </div>
            <router-link
                tag="div"
                to="/newclient"
                class="mr-4 button-new-order v-btn v-btn--contained v-btn--right v-btn--rounded v-btn--router theme--light v-size--default"
                >Оформить карту</router-link
            >
        </div>
    </div>
    <div
        class="client-card side-card company active"
        :class="actionsAllowed ? '' : 'disabled'"
        v-else-if="clientType == 'legal'"
    >
        <div
            class="client-info d-flex align-items-center justify-content-between"
        >
            <h4 class="client-name">
                <span class="client-edit" @click.prevent="changeClient">
                   <v-icon
                       color="green"
                   >
                    mdi-pencil
                  </v-icon>
                  </span>{{ client.customer.name }}
            </h4>
            <!-- <a href="" class="client-phone">Изменить</a> -->
        </div>
        <router-link
            tag="div"
            to="/order/clientcard"
            class="client-car-info d-flex align-items-center justify-content-between mt-3 px-3 py-2"
        >
            <div class="car-mark car-color car-red">
                <h5 class="car-name ml-2">
                    {{ chosenMark }} {{ chosenModel }}
                </h5>
            </div>
            <div
                class="tire-diameter d-flex align-items-center justify-content-between"
            >
                <b class="diameter mr-2">{{ diskSize }}</b>
                <img src="img/services/icons/diameter.png" alt="" />
            </div>
        </router-link>
        <div
            class="client-discount-info d-flex align-items-center justify-content-between mt-3"
        >
            <div class="client-discount">
                <span class="ml-2">{{ client.customer.phone }}</span>
            </div>
            <div
                class="car-number-block d-flex align-items-center justify-content-between"
            >
                <div class="car-number mr-2">
                    {{ client.plate || plateNumber }}
                </div>
                <img src="img/services/icons/flag.png" alt="" />
            </div>
        </div>
        <div
            class="left-to-discount position-relative d-flex align-items-center justify-content-between mt-3 px-3 py-3"
        ></div>
    </div>
    <div
        class="client-card side-card with-discount active"
        :class="actionsAllowed ? '' : 'disabled'"
        v-else-if="clientType == 'client'"
    >
        <div
            class="client-info d-flex align-items-center justify-content-between"
        >
            <h4 class="client-name" @click.prevent="changeClient">
                <span class="client-edit">
                   <v-icon
                       color="green"
                   >
                    mdi-pencil
                  </v-icon>
                </span> {{ client.customer.name }}
            </h4>
            <span class="client-phone">{{ client.customer.phone }}</span>
        </div>
        <router-link
            tag="div"
            to="/order/clientcard"
            class="client-car-info d-flex align-items-center justify-content-between mt-3 px-3 py-2"
        >
            <div class="car-mark car-color car-red">
                <h5 class="car-name ml-2">
                    {{ chosenMark }} {{ chosenModel }}
                </h5>
            </div>
            <div
                class="tire-diameter d-flex align-items-center justify-content-between"
            >
                <b class="diameter mr-2">{{ diskSize }}</b>
                <img src="img/services/icons/diameter.png" alt="" />
            </div>
        </router-link>
        <div
            class="client-discount-info d-flex align-items-center justify-content-between mt-3 row"
        >
            <div class="client-discount col-6">
                <b class="discount-count ml-2"
                    >{{
                        Math.trunc(
                            (this.client.discount.value +
                                this.client.additional_discount.value) *
                                100
                        ) || 0
                    }}%</b
                >
                <span class=" ml-2">скидка</span>
                <template v-if="chosenPromocode">
                    <span class="promocode-discount"
                        ><br />
                        <small
                            >{{ Math.trunc(chosenPromocode.amount) }}
                            {{
                                chosenPromocode.type == "percents"
                                    ? "%"
                                    : "руб."
                            }}
                            по промокоду</small
                        >
                    </span>
                </template>
            </div>
            <!--             <div class="car-number-block d-flex align-items-center justify-content-between">
                <div class="car-number mr-2">
                    в154рн78
                </div>
                <img src="img/services/icons/flag.png" alt="">
            </div> -->
            <div class="promocode col-6 py-0">
                <div class="form-row" v-if="ad">
                    <small class="d-block" v-if="!showPromocodeSelect"
                        ><a href="#" @click.prevent="showPromocodes()"
                            >У меня есть промокод</a
                        ></small
                    >
                    <div class="form-group d-flex" v-if="showPromocodeSelect">
                        <select
                            class="browser-default custom-select"
                            name="select-promocode"
                            v-model="chosenPromocode"
                        >
                            <option
                                v-for="(promocode, index) in promocodes"
                                :value="promocode"
                                :key="'promocod-' + index"
                                >{{ promocode.code }}</option
                            >
                        </select>
                        <small class="d-block ml-2 pt-2"
                            ><v-icon @click.prevent="closePromo"
                                >mdi-close-circle</v-icon
                            ></small
                        >
                    </div>
                </div>
            </div>
        </div>
        <template v-if="this.client.loyaltyEnabled">
            <div
                class="left-to-discount position-relative d-flex align-items-center justify-content-between mt-3 px-3 py-2"
            >
                <div class="">
                    <p class="left-text ml-2">
                        Осталось приобрести на
                        <span class="rubl">{{
                            (Math.floor(this.client.spent / this.client.thresholdOfDiscount) + 1) * this.client.thresholdOfDiscount -
                                this.client.spent
                        }}</span>
                        ₽
                    </p>
                </div>
                <div class="left-to-discount-circle rounded-circle text-center">
                    <span class="discount-count-text">будет</span>
                    <span class="discount-count">
                      {{ discountProc }}%
                    </span>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props: ["actionsAllowed"],
    async mounted() {
        this.$store.dispatch("fetchPromocodes");
    },
    computed: {
        ...mapGetters([
            "client",
            "clientType",
            "diskType",
            "diskSize",
            "runflat",
            "frameVehicle",
            "chosenMark",
            "chosenModel",
            "plateNumber",
            "promocodes",
            "cart",
            "order",
        ]),
        ...mapGetters('shift', [
          "shiftData",
        ]),
        discountProc () {
          return Math.trunc(
              (this.client.discount.value + this.client.additional_discount.value) * 100 + 1
          ) || 0
        },
        chosenPromocode: {
            get() {
                if (!this.$store.getters.chosenPromocode.display_title && Array.isArray(this.promocodes)) {
                  const item = this.promocodes?.find(v => v.code == this.$store.getters.chosenPromocode.code)
                  if (item == undefined || !item) {
                    return ''
                  } else {
                    return item
                  }
                } else {
                  return this.$store.getters.chosenPromocode;
                }
            },
            set(value) {
                this.$store.commit("updateChosenPromocode", value);
                this.$store
                    .dispatch("fetchPricesWithCartItems", {
                        cart: this.chosenServices,
                        promocode: this.chosenPromocode,
                        client: this.client
                    })
                    .finally(() => {
                        this.$store.dispatch("updateOrder", {
                            cart: this.cart,
                            client: this.client,
                            clientPhone: this.client.customer.phone ?? "",
                            promocode: this.chosenPromocode,
                            shift: this.shiftData,
                            status: this.order.status,
                            order_id: this.order.id,
                            runflat: this.runflat,
                            frameVehicle: this.frameVehicle,
                            mark: this.chosenMark ?? "",
                            model: this.chosenModel ?? "",
                            employee: this.choosenEmployee ?? ""
                        });
                    });
            }
        },
        chosenServices: {
            get() {
                return this.$store.getters.chosenServices;
            },
            set(value) {
                this.$store.commit("updateChosenServices", value);
            }
        }
    },
    data() {
        return {
            showPromocodeSelect: false,
            ad: this.actionsAllowed
        };
    },
    methods: {
        closePromo() {
            this.showPromocodeSelect = false;
            this.chosenPromocode = "";
        },
        showPromocodes() {
            if (this.actionsAllowed) {
                this.showPromocodeSelect = true;
            }
        },
        changeClient() {
          this.$store.dispatch("setChangeClientModal", true);
            // this.$modal.show("ChangeClientModal");
        }
    }
};
</script>

<style>
.promocode-autocomplete .v-text-field__details {
  display: none !important;
}
</style>
<style scoped>

.client-card.disabled {
    pointer-events: none;
    /* for "disabled" effect */
    opacity: 0.8;
    background: #ccc;
}

.promocode-discount {
    font-size: 15px;
    font-style: italic;
}

.client-edit {
    font-size: 16px;
}

.client-name,
.client-car-info {
    cursor: pointer;
}
</style>
